import type { UpcomingProduct } from '../types/product'

export const upcomingProducts: UpcomingProduct[] = [
  {
    id: 'waves',
    name: 'Waves',
    descriptionNo:
      'Bølgelaster for marine og kystnære konstruksjoner — lineær og ikke-lineær bølgeteori, diffraksjon og Morison-ligning. Aktuell for brygger, moloer og offshore støttestrukturer.',
    descriptionEn:
      'Wave loads for marine and coastal structures — linear and non-linear wave theory, diffraction and the Morison equation. Relevant for jetties, breakwaters and offshore support structures.',
    status: 'planned',
    icon: 'water'
  },
  {
    id: 'explosion',
    name: 'Explosion',
    descriptionNo:
      'Eksplosjonslaster og dimensjonering av konstruksjoner mot trykkbølger. Skalerte distanser, varighetsmodeller og dynamisk respons.',
    descriptionEn:
      'Blast loads and design of structures against pressure waves. Scaled distances, duration models and dynamic response.',
    status: 'planned',
    icon: 'fire'
  },
  {
    id: 'maintenance',
    name: 'Maintenance',
    descriptionNo:
      'Tilstandsvurdering og restkapasitet for eksisterende konstruksjoner — inspeksjonsdata, gjenværende bestandighet og dimensjonerende verdier under revurdering.',
    descriptionEn:
      'Condition assessment and residual capacity for existing structures — inspection data, remaining durability and design values under re-assessment.',
    status: 'planned',
    icon: 'tools'
  },
  {
    id: 'building-physics',
    name: 'Building Physics',
    descriptionNo:
      'Bygningsfysikk — varme, fukt, diffusjon og dugg. Integrert med byggklosser (vegger, tak, gulv) fra StructuraMatrix.Modules.',
    descriptionEn:
      'Building physics — heat, moisture, diffusion and condensation. Integrated with building assemblies (walls, roofs, floors) from StructuraMatrix.Modules.',
    status: 'planned',
    icon: 'thermometer-half'
  },
  {
    id: 'geotech',
    name: 'Geotech',
    descriptionNo:
      'Geotekniske beregninger — fundamenter, stabilitet, setninger, spunt og jordtrykk. Kopling til Kartverket/NGU-data og StructuraMatrix.Modules.Terrain.',
    descriptionEn:
      'Geotechnical calculations — foundations, stability, settlements, sheet piles and earth pressure. Integrated with Kartverket/NGU data via StructuraMatrix.Modules.Terrain.',
    status: 'planned',
    icon: 'layers'
  },
  {
    id: 'fire',
    name: 'Fire',
    descriptionNo:
      'Branndimensjonering av tre-, stål- og betongkonstruksjoner etter Eurocode — parametriske branner, isotermmetoden og redusert tverrsnitt.',
    descriptionEn:
      'Fire design of timber, steel and concrete structures to Eurocode — parametric fires, the isotherm method and reduced cross-section.',
    status: 'planned',
    icon: 'fire'
  }
]
